/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatisticalReportApiRequest } from '../../models/statistical-report-api-request';

export interface ApiHotelStatisticalReportExtraServicePost$Params {
      body?: StatisticalReportApiRequest
}

export function apiHotelStatisticalReportExtraServicePost(http: HttpClient, rootUrl: string, params?: ApiHotelStatisticalReportExtraServicePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelStatisticalReportExtraServicePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelStatisticalReportExtraServicePost.PATH = '/api/hotel/StatisticalReport/ExtraService';
